'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getColorStyleWithOpacity = getColorStyleWithOpacity;
exports.shadeColor = shadeColor;

var _HexCode = require('PatternValidationJS/patterns/HexCode');

var _HexCode2 = _interopRequireDefault(_HexCode);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getColorStyleWithOpacity(primaryColor) {
  var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.05;

  var rgbObject = _HexCode2.default.toRGB(primaryColor);

  return 'rgba(' + rgbObject.r + ', ' + rgbObject.g + ', ' + rgbObject.b + ', ' + opacity + ')';
}

function shadeColor(color, percent) {
  /**
   * Source code from: https://stackoverflow.com/questions/5560248/programmatically-lighten-or-darken-a-hex-color-or-rgb-and-blend-colors
   * @param {string} color - A hex color string (must start with #)
   * @param {int} percent - Percentage by which to lighten the color, can be negative
   * to darken color
   * @returns {string} color - A color, lightened by the given percentage
   */
  var num = parseInt(color.slice(1), 16);

  var red = (num >> 16) + percent;
  if (red > 255) red = 255;else if (red < 0) red = 0;

  var blue = (num >> 8 & 0x00ff) + percent;
  if (blue > 255) blue = 255;else if (blue < 0) blue = 0;

  var green = (num & 0x0000ff) + percent;
  if (green > 255) green = 255;else if (green < 0) green = 0;

  return '#' + (green | blue << 8 | red << 16).toString(16);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/utils/color.js
// module id = 136
// module chunks = 0